// Server-side pont that we are using to override
// Hardcoded for now since it's not deployed eyt
export const DefaultSettingPont = 4194304;
